import type { Media } from "../Media.js";
import type { Product } from "../Product.js";

export function getPrimaryImageOfProduct({ gallery }: Product): Media | undefined {
	return gallery.map(({ photo }) => photo).find(Boolean);
}
